import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import MisaService from "services/MisaService";
import Utils from "utils";
import openNotification from "utils/notification";

// GET DATA
export const getMisaAccountObjects = createAsyncThunk(
  "misa/getMisaAccountObjects",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getAccountObjects(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMisaInventoryItems = createAsyncThunk(
  "misa/getMisaInventoryItems",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getInventoryItems(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMisaStocks = createAsyncThunk(
  "misa/getMisaStocks",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getStocks(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMisaUnits = createAsyncThunk(
  "misa/getMisaUnits",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getUnits(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMisaBankAccounts = createAsyncThunk(
  "misa/getMisaBankAccounts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getBankAccounts(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getMisaOrganizationUnits = createAsyncThunk(
  "misa/getMisaOrganizationUnits",
  async (params, { rejectWithValue }) => {
    try {
      const response = await MisaService.getOrganizationUnits(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaAccountObjects = createAsyncThunk(
  "misa/saveMisaAccountObjects",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveAccountObjects(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaInventoryItems = createAsyncThunk(
  "misa/saveMisaInventoryItems",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveInventoryItems(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaStocks = createAsyncThunk(
  "misa/saveMisaStocks",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveStocks(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaUnits = createAsyncThunk(
  "misa/saveMisaUnits",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveUnits(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaBankAccounts = createAsyncThunk(
  "misa/saveMisaBankAccounts",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveBankAccounts(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaOrganizationUnits = createAsyncThunk(
  "misa/saveMisaOrganizationUnits",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveOrganizationUnits(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const saveMisaInventoryCategories = createAsyncThunk(
  "misa/saveMisaInventoryCategories",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.saveInventoryCategories(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const misaSyncData = createAsyncThunk(
  "misa/syncData",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await MisaService.syncData(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const misaSyncRetry = createAsyncThunk(
 "misa/syncRetry",
  async (data, { rejectWithValue }) => {
    try {
      const { logId, onSuccess } = data;
      const response = await MisaService.syncRetry(logId);
      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  accountObjects: [],
  inventoryItems: [],
  stocks: [],
  units: [],
  bankAccounts: [],
  organizationUnits: [],
  inventoryCategories: [],
};

export const misaSlice = createSlice({
  name: "misa",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    clearMisaData: (state) => {
      state.accountObjects = [];
      state.inventoryItems = [];
      state.stocks = [];
      state.units = [];
      state.bankAccounts = [];
      state.organizationUnits = [];
      state.inventoryCategories = [];
    },
  },
  extraReducers: (builder) => {
    builder
      /* ===== GET ===== */
      .addMatcher(
        (action) => action.type.startsWith("misa/get") && action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/get") && action.type.endsWith("/fulfilled"),
        (state, action) => {
          state.loading = false;
          const keyMap = {
            getMisaAccountObjects: "accountObjects",
            getMisaInventoryItems: "inventoryItems",
            getMisaStocks: "stocks",
            getMisaUnits: "units",
            getMisaBankAccounts: "bankAccounts",
            getMisaOrganizationUnits: "organizationUnits",
            getMisaInventoryCategories: "inventoryCategories",
          };
          const actionName = action.type.split("/")[1];
          state[keyMap[actionName]] = action.payload || [];
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/get") && action.type.endsWith("/rejected"),
        (state) => {
          state.loading = false;
        }
      )
      /* ===== SAVE ===== */
      .addMatcher(
        (action) => action.type.startsWith("misa/save") && action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/save") && action.type.endsWith("/fulfilled"),
        (state) => {
          state.loading = false;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/save") && action.type.endsWith("/rejected"),
        (state) => {
          state.loading = false;
        }
      )
      /* ===== SYNC ===== */
      .addMatcher(
        (action) => action.type.startsWith("misa/sync") && action.type.endsWith("/pending"),
        (state) => {
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/sync") && action.type.endsWith("/fulfilled"),
        (state) => {
          state.loading = false;
        }
      )
      .addMatcher(
        (action) => action.type.startsWith("misa/sync") && action.type.endsWith("/rejected"),
        (state) => {
          state.loading = false;
        }
      );
  },
});

export const { showLoading, clearMisaData } = misaSlice.actions;

export default misaSlice.reducer;